export default "__VITE_ASSET__DxIfuPTi__"